document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

class WflMenu extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-menu-toggle]');
    this.panel = this.querySelector('[data-menu-panel]');
    if (!this.button || !this.panel) return;

    this.button.addEventListener('click', () => {
      const open = this.button.getAttribute('aria-expanded') === 'true';
      this.button.setAttribute('aria-expanded', String(!open));
      this.panel.hidden = open;
      document.body.classList.toggle('menu-open', !open);
    });
  }
}

class WflProductForm extends HTMLElement {
  connectedCallback() {
    this.select = this.querySelector('[data-variant-select]');
    this.idInput = this.querySelector('input[name="id"]');
    this.price = this.querySelector('[data-current-price]');
    this.compare = this.querySelector('[data-compare-price]');
    this.badge = this.querySelector('[data-sale-badge]');
    this.button = this.querySelector('[data-add-button]');
    this.variantsNode = this.querySelector('[data-variants-json]');

    if (!this.select || !this.variantsNode) return;
    this.variants = JSON.parse(this.variantsNode.textContent);
    this.select.addEventListener('change', () => this.updateVariant());
  }

  updateVariant() {
    const variant = this.variants.find((item) => String(item.id) === this.select.value);
    if (!variant) return;

    this.idInput.value = variant.id;
    this.price.textContent = this.formatMoney(variant.price);

    const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    this.compare.hidden = !onSale;
    this.badge.hidden = !onSale;

    if (onSale) {
      this.compare.textContent = this.formatMoney(variant.compare_at_price);
      const percent = Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
      this.badge.textContent = `Save ${percent}%`;
    }

    this.button.disabled = !variant.available;
    this.button.textContent = variant.available ? this.button.dataset.availableText : this.button.dataset.soldText;
  }

  formatMoney(cents) {
    const currency = this.dataset.currency || 'USD';
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency
    }).format(cents / 100);
  }
}

if (!customElements.get('wfl-menu')) customElements.define('wfl-menu', WflMenu);
if (!customElements.get('wfl-product-form')) customElements.define('wfl-product-form', WflProductForm);
